import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthResponseData } from 'src/app/shared/models/authentication/auth-response-data';
import { GlobalFunction } from 'src/app/shared/global-function';
import { TutorialService } from 'src/app/shared/services/tutorial.service';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class UserMenuComponent implements OnInit {


  public showPersonalAvailability: boolean;
  
  constructor(private tutorialService: TutorialService) { }

  ngOnInit() 
  {
    let userRoles = GlobalFunction.getUserRoles();
    this.showPersonalAvailability = userRoles.indexOf("EmployeeSettings.MenuPersonalAvailability") >= 0;
  }

  public stopTutorial(): void
  {

        this.tutorialService.endTutorialComponent("my-appointments");
  }

}
